import { css } from '@emotion/react';

export const inter = css`
  @font-face {
    font-family: 'Inter';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: local('Inter Regular'), local('Inter-Regular'),
      url('https://static.utex.io/fonts/Inter-Regular.woff2') format('woff2'),
      url('https://static.utex.io/fonts/Inter-Regular.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: local('Inter Bold'), local('Inter-Bold'),
      url('https://static.utex.io/fonts/Inter-Bold.woff2') format('woff2'),
      url('https://static.utex.io/fonts/Inter-Bold.woff') format('woff');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 800;
    font-style: normal;
    font-display: swap;
    src: local('Inter ExtraBold'), local('Inter-ExtraBold'),
      url('https://static.utex.io/fonts/Inter-ExtraBold.woff2') format('woff2'),
      url('https://static.utex.io/fonts/Inter-ExtraBold.woff') format('woff');
  }
`;

export const defaultStylesInter = css`
  body {
    font-family: 'Inter', 'Arial', sans-serif;
    font-feature-settings: 'tnum', 'ss01', 'cv05', 'cv08';
    font-size: 1.4rem;
    line-height: 1.4285;
  }
`;

export const proxima = css`
  @font-face {
    font-family: 'ProximaNova';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('https://static.utex.io/fonts/proxima_nova_regular-webfont.woff2') format('woff2'),
      url('https://static.utex.io/fonts/proxima_nova_regular-webfont.woff') format('woff');
  }

  @font-face {
    font-family: 'ProximaNova';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('https://static.utex.io/fonts/proxima_nova_bold-webfont.woff2') format('woff2'),
      url('https://static.utex.io/fonts/proxima_nova_bold-webfont.woff') format('woff');
  }
`;

export const defaultStylesProxima = css`
  body {
    font-family: 'ProximaNova', 'Arial', sans-serif;
    font-feature-settings: 'tnum';
    font-size: 1.5rem;
    line-height: 1.4285;
  }
`;

export const dewi = css`
  @font-face {
    font-family: 'Dewi';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('https://static.utex.io/fonts/Dewi.woff2') format('woff2'),
      url('https://static.utex.io/fonts/Dewi.woff') format('woff');
  }
`;

export const defaultStylesDewi = css`
  body {
    font-family: 'Dewi', 'Arial', sans-serif;
    font-size: 1.5rem;
    line-height: 1.4285;
  }
`;

export const geometria = css`
  @font-face {
    font-family: 'Geometria';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('https://investment-s3.unitedtraders.biz/static/fonts/Geometria-Regular.woff2')
        format('woff2'),
      url('https://investment-s3.unitedtraders.biz/static/fonts/Geometria-Regular.woff')
        format('woff');
  }

  @font-face {
    font-family: 'Geometria';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('https://investment-s3.unitedtraders.biz/static/fonts/Geometria-Bold.woff2')
        format('woff2'),
      url('https://investment-s3.unitedtraders.biz/static/fonts/Geometria-Bold.woff') format('woff');
  }
`;

export const defaultStylesGeometria = css`
  body {
    font-family: 'Geometria', 'Arial', sans-serif;
    font-feature-settings: 'tnum';
    font-size: 1.5rem;
    line-height: 1.3333;
  }
`;
